var render = function render() {
  var _vm = this,
    _c = _vm._self._c
  return _c("div", { staticClass: "outer-wrapper" }, [
    _c(
      "div",
      { staticClass: "autocomplete-wrapper" },
      [
        _c("vue-google-autocomplete", {
          ref: "autocomplete",
          attrs: {
            id: "address-autocomplete",
            classname: "text-input",
            placeholder: "Enter Delivery Address",
            country: ["us"],
            defaultAddress: _vm.defaultAddress,
          },
          on: {
            "no-results-found": _vm.handleNoResults,
            placechanged: _vm.getAddressData,
            "address-set": _vm.handleInputChange,
            showLoading: _vm.clearErrorAndShowLoading,
          },
        }),
        _vm._v(" "),
        _vm.isLoggedIn
          ? _c(
              "button",
              {
                staticClass: "autocomplete-icon-address-set",
                attrs: {
                  type: "button",
                  "aria-label": "View Saved Delivery Addresses",
                },
                on: { click: _vm.toggleDropdown },
              },
              [_c("large-arrow-down")],
              1
            )
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "autocomplete-icon-address-set",
            attrs: {
              type: "button",
              "aria-label":
                "Map my address and show all available restaurants.",
            },
            on: {
              click: function ($event) {
                return _vm.$refs.autocomplete.updateOnEnter()
              },
            },
          },
          [_vm._v("\n\t\t\tGO\n\t\t")]
        ),
        _vm._v(" "),
        _vm.showDropdown
          ? _c(
              "div",
              {
                directives: [
                  {
                    name: "click-outside",
                    rawName: "v-click-outside",
                    value: _vm.closeDropdown,
                    expression: "closeDropdown",
                  },
                ],
                staticClass: "address-dropdown",
              },
              [
                _c(
                  "ul",
                  _vm._l(_vm.savedAddresses, function (address) {
                    return _c(
                      "li",
                      { key: address.id, staticClass: "address-dropdown-item" },
                      [
                        _c(
                          "button",
                          {
                            staticClass: "address-dropdown-button",
                            attrs: { type: "button" },
                            on: {
                              click: function ($event) {
                                return _vm.handleAddressSelect(
                                  address.addressSend,
                                  address.id
                                )
                              },
                            },
                          },
                          [
                            _vm._v(
                              "\n\t\t\t\t\t\t" +
                                _vm._s(address.label) +
                                " - " +
                                _vm._s(address.address) +
                                "\n\t\t\t\t\t"
                            ),
                          ]
                        ),
                      ]
                    )
                  }),
                  0
                ),
              ]
            )
          : _vm._e(),
      ],
      1
    ),
    _vm._v(" "),
    _vm.error
      ? _c("div", {
          staticClass: "error",
          domProps: { innerHTML: _vm._s(_vm.error) },
        })
      : _vm._e(),
    _vm._v(" "),
    _vm.showLoading
      ? _c("div", { staticClass: "loading" }, [_vm._v("Loading...")])
      : _vm._e(),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }